export const TLD_URL = 'https://data.iana.org/TLD/tlds-alpha-by-domain.txt';
export const CACHE_KEY = 'validTlds';
export const CACHE_EXPIRY_KEY = 'validTldsExpiry';
export const CACHE_TTL = 7 * 24 * 60 * 60 * 1000; // 7 days
